<template lang="html">
  <div class="poll">
    <!--Share-->
    <modal
      scrollable="true"
      :name="'share-poll' + $attrs.pollkey"
      height="auto"
    >
      <button class="absolute top-0 right-0 mt-4 mr-6" @click="closeShareModal">
        <i class="fas fa-times"></i>
      </button>
      <Share
        v-if="$attrs.type == 'poll'"
        :type="$attrs.poll.type"
        :question="$attrs.poll.question"
        :name="$attrs.poll.name"
      />
      <Share
        v-if="$attrs.type == 'group'"
        type="group"
        :question="$attrs.poll.group"
        :name="$attrs.poll.groupID"
      />
    </modal>

    <div
      @mouseleave="hover = false"
      @mouseover="hover = true"
      class="md:flex md:border-b pb-4 pt-4 px-4 md:px-2"
    >
      <span class="w-auto">
        <input
          v-if="$attrs.type == 'poll'"
          type="checkbox"
          class="mr-2 mt-2 leading-tight"
          @change="
            check($event.target.checked, {
              id: $attrs.pollkey,
              name: $attrs.poll.question,
              type: $attrs.type
            })
          "
        />

        <input
          v-if="$attrs.type == 'group'"
          type="checkbox"
          class="mr-2 mt-2 leading-tight"
          @change="
            check($event.target.checked, {
              id: $attrs.poll.groupID,
              name: $attrs.poll.group,
              polls: $attrs.poll.polls.keyList,
              type: $attrs.type
            })
          "
        />
      </span>

      <router-link
        v-if="$attrs.type == 'poll'"
        :to="{ name: 'edit-poll', params: { pollId: $attrs.pollkey } }"
        class="cursor-pointer w-full md:w-1/3"
      >
        <b class="text-push-black">{{ $attrs.poll.question }}</b>

        <b class="ml-2" v-if="hover">Edit</b>
        <span class="text-xs block text-push-gray"
          >Start: {{ niceDate($attrs.poll.startDate) }}</span
        >
      </router-link>

      <a
        @click="openGroupModal($attrs.poll.groupID)"
        class="cursor-pointer w-full md:w-1/3"
        v-if="$attrs.type == 'group'"
      >
        <b class="text-push-black">{{ $attrs.poll.group }}</b>
        <b class="ml-2" v-if="hover">Edit</b>
        <span class="text-xs block text-push-gray"
          >Start: {{ niceDate($attrs.poll.startDate) }}</span
        >
      </a>

      <span
        class="md:w-1/3 flex text-center bg-push-lightgray md:bg-white border md:border-none mt-2 md:mt-0 md:mx-2 p-2"
      >
        <span class="w-1/3 ml-3">
          <b v-if="$attrs.poll.groupID" class="block"
            >#{{ $attrs.poll.groupID }}</b
          >
          <b v-else class="block">N/A</b>
          <small class="text-push-gray">Group</small>
        </span>
        <span class="w-1/3 ml-3">
          <b class="block">{{ $attrs.poll.total }}</b>
          <small class="text-push-gray">Responses</small>
        </span>
        <span class="w-1/3 ml-3">
          <b v-if="$attrs.type == 'poll'" class="block">{{
            $attrs.poll.views
          }}</b>
          <b v-if="$attrs.type == 'group'" class="block">{{
            $attrs.poll.visits
          }}</b>
          <small class="text-push-gray">Views</small>
        </span>
      </span>
      <!--- Share/result Buttons -->
      <span class="md:w-1/3 flex text-center mx-2 p-2">
        <span class="block w-full cursor-pointer">
          <router-link
            v-if="$attrs.type != 'group'"
            class="my-1 md:w-auto border-push-blue border float-right bg-push-blue text-white p-3 ml-2 lg:mx-3"
            :to="{ name: 'poll', params: { id: $attrs.pollkey } }"
            ><span><i class="fas fa-long-arrow-alt-right"></i></span
          ></router-link>
          <router-link
            v-if="$attrs.type == 'group'"
            class="my-1 md:w-auto border-push-blue border float-right bg-push-blue text-white p-3 ml-2 lg:mx-3"
            :to="'group/' + $attrs.pollkey"
            ><span><i class="fas fa-long-arrow-alt-right"></i></span
          ></router-link>
          <a
            @click="openShare"
            class=" my-1 md:w-auto border-push-blue border align-middle float-right  p-3 text-push-blue lg:mx-3 lg:w-auto"
            ><div class="hidden lg:block">Share</div>
            <i class="fas fa-share-alt lg:hidden"></i
          ></a>
          <a
            v-if="!openResults"
            class=" my-1 mr-2 md:w-auto border-push-blue border align-middle float-right text-push-blue p-3 lg:mx-3"
            @click="openResults = true"
            ><div class="hidden lg:block">Results</div>
            <i class="fas fa-chart-pie lg:hidden"></i
          ></a>
          <a
            v-if="openResults"
            class="my-1 mr-2 md:w-auto border-push-gray border align-middle float-right text-push-gray bg-push-lightgray p-3 lg:w-auto lg:mx-3"
            @click="openResults = false"
            ><div class="hidden lg:block">Close</div>
            <i class="fas fa-times lg:hidden"></i
          ></a>
        </span>
      </span>
    </div>
    <!-- Open Results Panel-->
    <div
      class="block w-full bg-gray-200 flex-none  shadow animate__animated animate__fadeIn"
      v-if="openResults"
    >
      <!-- Poll -->
      <div v-if="$attrs.type == 'poll'" class="mx-auto flex text-center">
        <div
          v-for="(answer, index) in $attrs.poll.answers"
          v-bind:key="index"
          class="p-4 md:p-16 mb-2 md:mb-auto answer-row text-center w-full text-gray-800 block"
        >
          <span
            v-if="$attrs.poll.total != 0"
            class="percent text-2xl md:text-6xl font-bold"
            >{{
              Math.round((answer.answer_count / $attrs.poll.total) * 100)
            }}%</span
          >
          <span
            v-if="$attrs.poll.total == 0"
            class="percent text-2xl md:text-6xl font-bold"
            >0%</span
          >
          <span class="block font-semibold">
            {{ answer.label }}
          </span>
          <br />
          <span class="text-xs">{{ answer.answer_count }} clicks</span>
        </div>
      </div>

      <!-- Group -->
      <div v-if="$attrs.type == 'group' && $attrs.groupResults" class=" mx-8">
        <div
          v-for="(poll, i) in $attrs.groupResults"
          v-bind:key="i"
          class="w-full"
        >
          <span class="block pt-4 pb-4 text-xl border-b">{{
            poll.question
          }}</span>
          <div class="flex flex-wrap">
            <div
              v-for="(answer, index) in poll.answers"
              v-bind:key="index"
              class="p-16 w-1/2 answer-row text-center md:w-auto text-gray-800 block"
            >
              <span
                v-if="poll.total != 0"
                class="percent text-2xl md:text-4xl font-bold"
                >{{
                  Math.round((answer.answer_count / poll.total) * 100)
                }}%</span
              >
              <span
                v-if="poll.total == 0"
                class="percent text-2xl md:text-4xl font-bold"
                >0%</span
              >
              <span class="block font-semibold">
                {{ answer.label }}
              </span>
              <br />
              <span class="uk-text-small"
                >{{ answer.answer_count }} clicks</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Share from "@/components/dashboard/polls/Share.vue";
import vmodal from "vue-js-modal";
export default {
  components: {
    Share,
    vmodal
  },
  data() {
    return {
      hover: false,
      openResults: false,
      actionList: []
    };
  },
  methods: {
    openGroupModal(key) {
      this.$emit("openGroupEdit", key);
    },
    openShare() {
      this.$modal.show("share-poll" + this.$attrs.pollkey);
    },
    closeShareModal() {
      this.$modal.hide("share-poll" + this.$attrs.pollkey);
    },
    check(event, object) {
      if (event) {
        this.$emit("addtoAction", object);
      } else {
        this.$emit("removeAction", object.id);
      }
    },
    niceDate(date) {
      return moment(date).format("Do MMMM Y");
    }
  }
};
</script>
